import { ISuggestion } from '../../models'
import { BaseHttpService } from './base'

class SuggestionService extends BaseHttpService {
  public addSuggestion = async (suggestion: ISuggestion): Promise<any> => {
    return this.post('suggestions', suggestion)
  }
}

export default new SuggestionService()
